import React, {useState, useContext} from 'react';
import {
    AppContainer,
    ContentContainer, DisabledContext, Icons, Modal, SideBar, SideBarLogo,
    SideBarNavGroup,
    SideBarNavItem, SideBarSpacer, Text, Variants
} from "toolbox-react-frontend-components";
import {Outlet, useNavigate, useLocation, matchPath} from "react-router-dom";
import {route} from "ziggy-js";
import {logout} from "../../../helpers/AuthHelper";

const AdminLayout = () => {
    const [navOpen, setNavOpen]                 = useState(false);
    const [logoutModalOpen, setLogoutModalOpen] = useState(false);

    const navigate = useNavigate();
    let location = useLocation();

    const {
        disabled,
    } = useContext(DisabledContext);

    const handleNavClick = (callback) => {
        setNavOpen(false);

        callback();
    }

    return (
        <>
            <AppContainer>
                <SideBar
                    dropdownDisplay={navOpen}
                    onDropdown={() => setNavOpen(!navOpen)}
                    topSlot={(
                        <SideBarLogo
                            onClick={(event) => handleNavClick(() => navigate(route('admin.dashboard', undefined, false)))}
                            disabled={disabled}
                        >
                            Admin
                        </SideBarLogo>
                    )}
                    middleSlot={(
                        <>
                            <SideBarNavItem
                                label={'Dashboard'}
                                onClick={(event) => handleNavClick(() => navigate(route('admin.dashboard', undefined, false)))}
                                disabled={disabled}
                                active={!!matchPath(location.pathname, route('admin.dashboard', undefined, false))}
                            />
                            <SideBarNavItem
                                label={'Albums'}
                                onClick={(event) => handleNavClick(() => navigate(route('admin.album.index', undefined, false)))}
                                disabled={disabled}
                                active={!!location.pathname.startsWith(route('admin.album.index', undefined, false), 0)}
                            />
                            <SideBarNavItem
                                label={'Settings'}
                                onClick={(event) => handleNavClick(() => navigate(route('admin.setting.index', undefined, false)))}
                                disabled={disabled}
                                active={!!location.pathname.startsWith(route('admin.setting.index', undefined, false), 0)}
                            />
                        </>
                    )}
                    bottomSlot={(
                        <>
                            <SideBarSpacer />
                            <SideBarNavGroup
                                label={'Settings'}
                                disabled={disabled}
                                dropdownEnabled={false}
                            >
                                <SideBarNavItem
                                    label={'Profile'}
                                    onClick={(event) => handleNavClick(() => navigate(route('admin.profile.edit', undefined, false)))}
                                    disabled={disabled}
                                    active={!!matchPath(location.pathname, route('admin.profile.edit', undefined, false))}
                                />
                                <SideBarNavItem
                                    label={'Logout'}
                                    onClick={(event) => handleNavClick(() => setLogoutModalOpen(true))}
                                    disabled={disabled}
                                />
                            </SideBarNavGroup>
                        </>
                    )}
                />
                <ContentContainer >
                    <Outlet />
                </ContentContainer>
            </AppContainer>
            <Modal
                open={logoutModalOpen}
                title={'Are you sure you want to logout?'}
                icon={Icons.LOGOUT}
                confirmText={'Logout'}
                onConfirm={() => logout()}
                closeText={'Cancel'}
                onClose={() => setLogoutModalOpen(false)}
                disabled={disabled}
                variant={Variants.Warning}
            >
                <Text className={'mb-0'}>
                    Are you sure you want to logout?
                </Text>
            </Modal>
        </>
    );
}

export default AdminLayout;
